// Import action types related to getEventForm data
import {
    GETEVENTSFORM_FETCH_DATA_SUCCESS,
    GETEVENTFORM_HAVE_ERROR,
    GETEVENTSFORM_ARE_LOADING,
  } from "../actionType";
  
  // Retrieve default data from local storage if available, otherwise set as an empty array
  const defaultData = localStorage.getItem("SandeshHome") || [];
  // Define the initial state for the getEventFormReducer
  const initialState = {
    data: defaultData,
    loading: true,
    error: [], // Initialize error as null for better error handling
  };
  
  // Reducer function to handle getEventForm-related actions and update state accordingly
  export function getEventFormReducer(state = initialState, action) {
    switch (action.type) {
      // Handle error case when fetching getEventForm data
      case GETEVENTFORM_HAVE_ERROR:
        return {
          ...state,
          error: action.hasError, // Update the error state with the error from the action
          loading: false, // Set loading to false since the request is complete
        };
  
      // Handle loading state when getEventForm data is being fetched
      case GETEVENTSFORM_ARE_LOADING:
        return {
          ...state,
          loading: action.isLoading, // Update the loading state with the loading status from the action
        };
  
      // Handle success case when getEventForm data is successfully fetched
      case GETEVENTSFORM_FETCH_DATA_SUCCESS:
        return {
          ...state,
          data: action.event, // Update the data state with the fetched getEventForm data
          loading: false, // Set loading to false since the request is complete
          error: null, // Clear any previous errors
        };
  
      // Return the current state by default if action type is not recognized
      default:
        return state;
    }
  }
  